import styled from 'styled-components'
import colors from 'Assets/colors'

export const Description = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${colors.black};
  margin-bottom: 3rem;
  margin-top: 1rem;
`

export const ButtonLiteral = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`
